// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./" + {"344":"modules/dropdown","502":"polyfills/fetch","679":"polyfills/intersectionobserver","721":"polyfills/proxy","838":"polyfills/abortController","878":"modules/tooltip"}[chunkId] + ".bundle.js";
};